import React from "react";
export const LoggedContext = React.createContext();
